import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import { requireSession } from './auth/guard.js'

/**
 * Route table. Every view is lazily imported so the Vue Flow canvas — by far
 * the heaviest chunk — is not downloaded by someone who only opens the flow
 * list.
 */
const routes: RouteRecordRaw[] = [
  { path: '/', redirect: { name: 'flows' } },
  {
    path: '/login',
    name: 'login',
    meta: { public: true },
    component: () => import('./modules/common/pages/LoginPage.vue'),
  },
  {
    path: '/flows',
    name: 'flows',
    component: () => import('./modules/flows/pages/FlowListPage.vue'),
  },
  {
    path: '/flows/:id',
    name: 'flow-editor',
    component: () => import('./modules/editor/pages/FlowEditorPage.vue'),
  },
  {
    path: '/flows/:id/runs',
    name: 'flow-runs',
    component: () => import('./modules/runs/pages/FlowRunsPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    meta: { public: true },
    component: () => import('./modules/common/pages/NotFoundPage.vue'),
  },
]

export const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach(requireSession)
